import homeCopyUpdated from "./homeCopy.updated"

/** @type {import("./homeCopy.types").HomeCopy} */
export const homeCopy = homeCopyUpdated
